import { FilterStatus } from "@/components/StatusTableTab";
import { usePersistedState } from "@/hooks/usePersistedState";
import { ReactNode, useCallback, useMemo } from "react";
import { AdditionalFiltersContext } from "./AdditionalFiltersContext";

export function AdditionalFiltersProvider({
  children,
  storageKey,
  persistInSearchParams,
}: {
  children: ReactNode;
  storageKey: string;
  persistInSearchParams?: boolean;
}) {
  const [filterStatus, setFilterStatus] = usePersistedState<FilterStatus>(
    "all",
    {
      storageKey: `${storageKey}.filterStatus`,
      urlKey: persistInSearchParams !== false ? "status" : undefined,
    },
  );

  const [setId, setSetId] = usePersistedState<string | undefined>(undefined, {
    storageKey: `${storageKey}.setId`,
    urlKey: persistInSearchParams !== false ? "set" : undefined,
  });

  const computeFilterStatusQueryContent = useCallback(
    <T,>(statusField: keyof T) => {
      if (statusField == undefined) return {};
      if (filterStatus === "all")
        return { [statusField]: { in: ["published", "draft"] } };
      return { [statusField]: filterStatus };
    },
    [filterStatus],
  );

  const setWhereQuery = useMemo(
    () =>
      setId != undefined
        ? {
            relatedEnsemble: {
              some: {
                id: setId,
              },
            },
          }
        : {},
    [setId],
  );

  return (
    <AdditionalFiltersContext.Provider
      value={{
        setWhereQuery,
        filterStatus,
        setFilterStatus,
        computeFilterStatusQueryContent,
        setId,
        setSetId,
      }}
    >
      {children}
    </AdditionalFiltersContext.Provider>
  );
}
